import { Icons } from '@common';
import type { ReactElement } from 'react';

export function ErrorCellRenderer(params: { value: boolean }): ReactElement {
  return (
    <div className='action-cell'>
      {params.value ? (
        <Icons name='CheckCircleOutlined' style={{ color: 'green' }} />
      ) : (
        <Icons name='CloseCircleOutlined' style={{ color: 'red' }} />
      )}
    </div>
  );
}
